const Const = {
  TEST_EMAIL: [
    'jewel.han@gmail.com',
    'wave_m@kakao.com',
    'ty.yu@cndfactory.com',
    'bh.yu@cndfactory.com',
    'lcd3699@naver.com',
    'gjy0607@gmail.com',
    'tonightu@gmail.com',
    'minje.oh@cndfactory.com',
    'taejun.cho@cndfactory.com',
  ],
  REG_EXP_BLANK: /(\s*)/g,
  /* eslint-disable-next-line */
  REG_EXP_SPECIAL: /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g,
  HEADER_TITLE:{
    APPLY:10,
    MY:20,
    TERM:30,
    SHOT:40,
  },
  ////////
  MORPH: {
    CARE_CDK: 10,
    CARE: 12,
    CALC: 16,
    DEALER_AGENT_CDK: 22,
    PKG: 30,
    PROD: 34,
    PROMO: 38,
    RECORD_CDK: 42,
    SUBSC: 50,
    USER: 70,
    VEHICLE: 90,
    VEHICLE_CAT: 94,
  },
  ////////

  // 상품 제공 기준
  PKG_PROD_UNIT_TYPE_NUMBER: 10,    // 횟수
  PKG_PROD_UNIT_TYPE_CURRENCY: 20,  // 금액

  PKG_VEHICLE_CAT_COST_UNIT_MAX: 999999,
  PKG_VEHICLE_CAT_COST_PERIOD: { //TERMS: {
    0: '~ 48개월',
    1: '49개월 ~ 60개월',
    2: '61개월 ~ 72개월',
    3: '73개월 ~ 84개월',
    4: '85개월 ~ 96개월',
    5: '97개월 ~ 108개월',
    6: '109개월 ~ 120개월',
    7: '121개월 ~',
  },

  PROD:{
    ICON: {
      10: 1,
      20: 2,
      30: 3,
      40: 4,
      50: 5,
      60: 6,
      70: 7,
      80: 8,
      90: 9,
    },
    TYPE:{
      DEALER : 10,     //딜러수리
      CARE : 20,       //정비할인
      ASSURANCE : 30,  //보험
    },
  },

  PROMO: {
    CUT_UNIT: {      // 절사단위
      FLOOR: 1,      // 버림
      ROUND: 2,      // 반올림
      CEIL: 3,       // 올림
    },
    TYPE_OVERLAP: {
      ENABLE: 1, // 중복가능
      DISABLE: -1, //중복불가
    },
    STATE:{
      ENABLE:1,
      DISABLE:-1,
    }
  },

  // vip 코드할인 사용 시 프로모션 중복적용 가능여부
  PROMO_TYPE_OVERLAP_ENABLE: 1,   //중복가능
  PROMO_TYPE_OVERLAP_DISABLE: -1, //중복불가

  // 프로모션 unit 적용 기준
  PROMO_TYPE_RATE_RATE: 10, //비율
  PROMO_TYPE_RATE_UNIT: 20, //금액
  PROMO_TYPE_RATE_RAFFLE: 30, //추첨

  // 프로모션 구독상태별 적용
  PROMO_TYPE_SUBSC_NEW: 1,     // 신규구독
  PROMO_TYPE_SUBSC_EXT: 2,     // 연장구독
  PROMO_TYPE_SUBSC_SLUG: 3,    // 쿠폰사용

  STATE:{
    ABNORMAL : -50,
    PENDING : -40,
    DISABLE : -10,
    NONE : 1,
    ENABLE : 10,
    PROGRESS : 20,
    NORMAL : 50,
  },

  SUBSC_PAYMENT_PRICE_REFUND_NOT_ALLOWED : -99999999,//해지불가

  ERROR_CODE: {
    SUBSC_ESCALATION_GO_OAS: 5030, // OAS 차량등록 이동
    UBSC_ESCALATION_GO_SCP: 5031, // SCP guide 가입첫화면 이동

    PM_KCP_RESOPONSE_ERROR: 5021,
    SUBSC_FAIL_CREATE: 5020, //구독 결제 요청 생성 실패
    SUBSC_FAIL_DAC_EMPTY: 5015, //결제 지점 존재하지 않음
    SUBSC_FAIL_EXISTS: 5011, //요청된 구독이 이미 존재
    //REDIRECT_CREATE: 10,EXISTS
  },

  // 구독해지 시 해지 사유 설정
  SUBSC_STATE_REVOKE_REASON_PROD: 1,
  SUBSC_STATE_REVOKE_REASON_COST: 2,
  SUBSC_STATE_REVOKE_REASON_USAGE: 3,
  SUBSC_STATE_REVOKE_REASON_SWITCH: 4,
  SUBSC_STATE_REVOKE_REASON_ETC: 5,

  SUBSC_STATE: {
    DISABLE_REVOKE_REFUND_CONFIRM: -60, //환불완료
    DISABLE_REVOKE_REFUND: -50, //환불
    DISABLE_REVOKE: -20,//해지
    DISABLE_EXPIRE: -10,//기간만료
    NONE: 10,//구독없음
    ENABLE_REQ: 15,//가입신청
    ENABLE: 20,//구독중
  },

  SUBSC_STATE_REQ: {
    DISABLE_REVOKE_REFUND: -50, //환불신청
    DISABLE_REVOKE_CONFIRM: -40, //해지처리
    DISABLE_REVOKE_CANCEL: -30, //해지신청취소
    DISABLE_REVOKE: -20, //해지신청,
    NONE: 10, //신청없음
    ENABLE_EXT: 30, //연장신청
  },

  SUBSC_ATT: {
    FORM: 10, //구독 신청서
    REG: 20, //차량 등록증
    PANEL: 30, //차량 계기판
    INSP: 40, //차량 검사표
  },

  SUBSC_CONFIRM: {
    WAIT: 10,    //승인대기
    TRUE: 20,    //승인완료
    FALSE: -10,  //반려
  },

  SUBSC_ATT_CONFIRM: {
    WAIT: 10,    //미확인
    TRUE: 20,    //적합
    FALSE: -10,  //부적합
  },

  CARD_TYPE: {
    DEF: 10, //일반
    COM: 20, //법인
  },

  getErrorCodes: function() {
    return [
      Const.ERROR_CODE.SUBSC_FAIL_CREATE,
      Const.ERROR_CODE.SUBSC_FAIL_EXISTS,
      Const.ERROR_CODE.SUBSC_FAIL_DAC_EMPTY,
    ];
  },

  getSubscStateRevokeReason: function() {
    return {
      [Const.SUBSC_STATE_REVOKE_REASON_PROD]: '제공 서비스 불만족',
      [Const.SUBSC_STATE_REVOKE_REASON_COST]: '서비스 비용 불만족',
      [Const.SUBSC_STATE_REVOKE_REASON_USAGE]: '이용 빈도 적음',
      [Const.SUBSC_STATE_REVOKE_REASON_SWITCH]: '보유 차량 변경',
      [Const.SUBSC_STATE_REVOKE_REASON_ETC]: '기타'
    };
  },

  getSubscAttConfirmTitle: function() {
    return {
      [Const.SUBSC_ATT_CONFIRM.WAIT]: '미확인',
      [Const.SUBSC_ATT_CONFIRM.TRUE]: '적합',
      [Const.SUBSC_ATT_CONFIRM.FALSE]: '재촬영',
    }
  },

  getSubscConfirmTitle: function() {
    return {
      [Const.SUBSC_CONFIRM.WAIT]: '승인대기',
      [Const.SUBSC_CONFIRM.TRUE]: '승인완료',
      [Const.SUBSC_CONFIRM.FALSE]: '반려',
    }
  },

  getTakePictureType() {
    return {
      [Const.SUBSC_ATT.INSP]: 2,
      [Const.SUBSC_ATT.PANEL]: 1,
    }
  },
  
  getPaymentCardType() {
    return {
      [Const.CARD_TYPE.DEF]: '일반카드',
      [Const.CARD_TYPE.COM]: '법인카드',
    }
  },

  getSubscDateEnable: function() {
    return 2;
  },

  getSubscDateEnableAssurance: function() {
    return 30;
  },

  //연장신청 가능 날짜
  getSubscDateExtend: function () {
    return 30;
  },


  getVat: (price) => {
    return Math.floor(price / 11);
  },

  getPriceSubVat: (price) => {
    return price - Const.getVat(price);
  },

  getPriceAddVat: (price) => {
    return price * 1.1;
  },

  getPriceAddVatRound: (price) => {
    return Math.round(Const.getPriceAddVat(price));
  },

  getPriceAddVatCeil: (price) => {
    return Math.ceil(Const.getPriceAddVat(price));
  },

  getPriceAddVatFloor: (price) => {
    return Math.floor(Const.getPriceAddVat(price));
  },

  camelToSnake:  (str) => {
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
  },

  snakeToCamel: (str) => {
    return str.toLowerCase().replace(/([-_][a-z])/g, group =>
      group
        .toUpperCase()
        .replace('-', '')
        .replace('_', '')
    );
  }
  
  
};

export default Const;